module.exports = __webpack_public_path__ + "media/images/flags/PA-5bb0169a9b2aa72f005294fa9b5adc4e.svg";